import { API_URL, PRODUCTION_API_URL, saveAuthSession } from '@/lib/apiConfig';
import React, { useState } from 'react';
import { SignInWithApple } from '@capacitor-community/apple-sign-in';
import { isNativeApp, nativeRequestHeaders } from '@/lib/native';
import { Button } from '@/components/ui/button';

export default function AppleSignInButton({ link = false, linked = false }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (!isNativeApp() || window.Capacitor?.getPlatform?.() !== 'ios') return null;
  if (link && API_URL !== PRODUCTION_API_URL) return null;
  async function signIn() {
    if (link && !window.confirm('Link your Apple account to this signed-in portal account? Your existing profile, assignments and approval will stay with this account.')) return;
    setBusy(true); setError('');
    try {
      const headers = { 'Content-Type': 'application/json', ...nativeRequestHeaders() };
      const configuration = await fetch(`${PRODUCTION_API_URL}/auth/apple-configuration`, { headers });
      if (!configuration.ok || !(await configuration.json()).configured) throw new Error('Sign in with Apple is not configured on the server yet. Please use your existing sign-in method for now.');
      let nonce = crypto.randomUUID();
      if (link) {
        headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
        const challenge = await fetch(`${PRODUCTION_API_URL}/auth/apple-link-challenge`, { method: 'POST', headers });
        const data = await challenge.json();
        if (!challenge.ok) throw new Error(data.error || 'Unable to start account linking');
        nonce = data.nonce;
      }
      const { response } = await SignInWithApple.authorize({
        clientId: 'uk.co.seikosportstech.sep', redirectURI: 'https://sep.seikosportstech.co.uk/login',
        scopes: 'email name', nonce, state: crypto.randomUUID(),
      });
      const res = await fetch(`${PRODUCTION_API_URL}/auth/${link ? 'apple-link' : 'apple-exchange-token'}`, {
        method: 'POST', headers,
        body: JSON.stringify({ authorizationCode: response.authorizationCode, nonce,
          fullName: { givenName: response.givenName, familyName: response.familyName } }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Apple sign-in failed');
      if (link) { window.location.reload(); return; }
      saveAuthSession(data.token, 'production');
      window.location.href = '/';
    } catch (err) { setError(err.message || 'Apple sign-in was cancelled or failed.'); }
    finally { setBusy(false); }
  }
  if (linked) return <p className="text-sm text-green-700">Apple account linked. You can sign in with Apple or your existing login method.</p>;
  return <div className="space-y-2">
    <Button type="button" onClick={signIn} disabled={busy} className="w-full h-11 bg-black text-white hover:bg-slate-800">{busy ? (link ? 'Linking...' : 'Signing in...') : (link ? 'Link Apple account' : 'Sign in with Apple')}</Button>
    {!link && <p className="text-xs text-slate-500">Already have an account? Sign in with your existing method, then link Apple under My Profile &gt; Account.</p>}
    {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
  </div>;
}
